import { lazy } from "react";

import pathRoutes from "routes/pathRoutes";

const MainPage = lazy(() => import("./Pages/Main"));

export const personnelFormRoutes = [
  {
    page: MainPage,
    path: pathRoutes.personnelForm,
  },
];
